// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from '@/store'
import '@/infrastructure/Filters'

Vue.config.productionTip = false

/* eslint-disable no-new */
window.componentsLayoutPageVue = new Vue({
  store,
  render: h => h(App)
}).$mount('#components-layout')
